import { createSelector } from '@ngrx/store';
import { IPolCoreState } from 'src/app/core/models/state.model';
import { selectCoreFeatureState } from 'src/app/core/state/core.selectors';
import { INavigationState } from './navigation.model';

export const selectNavigationFeatureState = createSelector(
  selectCoreFeatureState,
  (state: IPolCoreState) => state?.navigationState
);

export const selectNavItems = createSelector(
  selectNavigationFeatureState,
  (state: INavigationState) => state?.isLoading ? undefined : state?.navItems
);

export const selectNavigationFavorites = createSelector(
  selectNavigationFeatureState,
  (state: INavigationState) => state?.favorites
);

export const selectShouldHideNavigation = createSelector(
  selectNavigationFeatureState,
  (state: INavigationState) => state?.shouldHide || false
);
